<script>
import { mergeData } from 'vue-functional-data-merge';

function onMouseEnter(event, cssClasses) {
  event.target.classList.add(cssClasses.rowHover);
}

function onMouseLeave(event, cssClasses) {
  event.target.classList.remove(cssClasses.rowHover);
}

export default {
  functional: true,
  inject: ['cssClasses'],
  props: {
    row: { type: Object, required: true },
    rowProp: { type: Object, required: false, default: () => ({}) },
    rowClassName: { type: Function, default: null },
    hover: { type: Boolean, default: true },
  },
  render(createElement, {
    props, injections, data, children,
  }) {
    const { cssClasses } = injections;
    const { row, rowProp, rowClassName } = props;

    // const rowProp = table.rowProps[row.id];

    const classes = {
      [cssClasses.row]: true,
    };

    if (rowProp.isHighlight) classes[cssClasses.rowHighlight] = true;
    if (rowProp.isHover) classes[cssClasses.rowHover] = true;
    if (rowClassName) classes[rowClassName(row)] = true;

    const localData = {
      class: classes,
      on: props.hover ? {
        mouseenter: event => onMouseEnter(event, cssClasses),
        mouseleave: event => onMouseLeave(event, cssClasses),
      } : {},
    };

    return createElement('tr', mergeData(data, localData), children);
  },
};
</script>
